declare global {
  interface Date {
    addDays(days: number): Date;
    addMonths(months: number): Date;
    addYears(years: number): Date;
    resetLocalTimeToTwelveAm(): Date;
  }
}

Date.prototype.addDays = function(days: number): Date {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Date.prototype.addMonths = function (months: number): Date {
    let tempDate = new Date(this.getTime());
    return new Date(tempDate.setMonth(tempDate.getMonth() + months));
}

Date.prototype.addYears = function (years: number): Date {
    let tempDate = new Date(this.getTime());
    return new Date(tempDate.setFullYear(tempDate.getFullYear() + years));

};

Date.prototype.resetLocalTimeToTwelveAm = function (): Date {
    const tempDate = new Date(this.getTime());
    return new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
};

export {};